export default {
  id: 63,
  title: 'Target #63 - Command Key',
  url: 'https://cssbattle.dev/play/63',
  colors: ['#191919', '#5DBCF9'],
  solution:
    '<a a><a b><a c><a d><a e><style>body{background:#191919}a{position:fixed;border:10px solid #5dbcf9;width:50;height:50}a[a]{top:114;left:166}a[b],a[c]{top:54}a[d],a[e]{bottom:56}a[b],a[e]{left:106}a[c],a[d]{right:104}a[b]{border-radius:50px 50px 0 50px}a[c]{border-radius:50px 50px 50px 0}a[d]{border-radius:0 50px 50px 50px}a[e]{border-radius:50px 0 50px 50px}</style>',
}
